import Vue from 'vue'

const store = {
  // global store state
  state: {
    application: {
      car_type: '',
      monthly_budget: '',
      city: '',
      province: '',
      first_name: '',
      last_name: '',
      email: '',
      home_phone: '',
      monthly_income: null,
      work_phone: null,
      income_detail: null,
      select_paid_frequency: null,
      consent_CEMs: 0,
      submitted_app: false,
      twilio_phone_verified: false
    },
    vehicleUsed: null,
    bank: '',
    payFrequencyAndAmount: {},
    isEmployed: true,
    addressFallback: false
  },

  /**
   * Update Application
   * @desc Use Vue.set() to define dynamic application properties
   * @param {string} field - application field to update
   * @param {string | number} value - value for the specified field
   */
  updateApplication (field, value) {
    let sanitizedValue = value
    if (Object.prototype.toString.call(sanitizedValue) === '[object String]') {
      sanitizedValue = sanitizedValue.trim()
    }
    Vue.set(
      this.state.application,
      field,
      sanitizedValue
    )
  },

  /**
   * Update Employment
   * Determines if user sees the 'employment-details" step
   * @param {boolean} value
   */
  enableAddressFallback () {
    this.state.addressFallback = true
  },

  /**
   * Update Employment
   * Determines if user sees the 'employment-details" step
   * @param {boolean} value
   */
  updateEmployment (value) {
    this.state.isEmployed = value
  },

  /**
   * Resets then updates the new "pay_per_<frequency>: <amount>"
   *
   * @desc One input controls 6 potential "pay_per_<frequency>" fields,
   * because of this we store the key/value pair in an object then
   * just reset the object every time the field is updated
   *
   * @param {string} key - ex: "pay_per_week", "pay_per_month", ...
   * @param {string} value -- ex: "500", "2000", ...
  */
  updatePaymentFrequencyAndAmount (key, value) {
    this.resetPaymentFrequencyAndAmount()
    this.state.payFrequencyAndAmount[key] = value
  },

  /**
   * Resets the payFrequencyAndAmount object
   *
   * @desc teardown state for the user's pay frequency and amount in the $store
  */
  resetPaymentFrequencyAndAmount () {
    Vue.set(this.state, 'payFrequencyAndAmount', {})
  },

  updateBank (bank) {
    this.state.bank = bank
  }
}

export default store
